import { render, staticRenderFns } from "./MobileOrderHistory.vue?vue&type=template&id=11580e4b&"
import script from "./MobileOrderHistory.vue?vue&type=script&lang=js&"
export * from "./MobileOrderHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports